import styled from 'styled-components';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Link = styled(CustomLink)`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 15px;
  border-radius: 14px;
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: ${({ theme }) => theme.palette.secondary.background};

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.palette.secondary.border};
    }
  }
`;

export const BellImage = styled.img`
  display: block;
`;

export const Text = styled(Typography.Caption)`
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0;
  color: ${({ theme }) => theme.palette.system.blue};
`;
